import { z } from "zod";

export const promocodeSchema = () => {
  return z.object({
    agreement: z.number().optional().nullable(),
    code: z.string().min(1),
    max_usage: z.union([z.number(), z.string()])
      .transform(val => val !== null && val !== undefined ? Number(val) : null)
      .optional()
      .nullable(),
    valid_for: z.union([z.number(), z.string()])
      .transform(val => val !== null && val !== undefined ? Number(val) : null)
      .optional()
      .nullable(),
    valid_until: z.union([z.string(), z.date()])
      .transform(val => {
        if (val === null || val === undefined) return val;
        const date = val instanceof Date ? val : new Date(val);
        return isNaN(date.getTime()) ? val : date.toISOString().split('T')[0];
      })
      .optional()
      .nullable(),
    active: z.boolean().optional(),
  });
};

export type PromocodeFormValues = z.infer<ReturnType<typeof promocodeSchema>>;
